import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Eleicao } from 'src/app/models/eleicao.model';
import { EleicaoService } from 'src/app/services/eleicao.service';

@Component({
  selector: 'app-resultado-parcial-eleicao',
  templateUrl: './resultado-parcial-eleicao.component.html',
  styleUrls: ['./resultado-parcial-eleicao.component.css']
})
export class ResultadoParcialEleicaoComponent implements OnInit {

  public token: any;
  public idEleicao: any;
  // public eleicao: Eleicao;
  constructor(
    protected router: Router,
    public route: ActivatedRoute,
    protected eleicaoServices: EleicaoService,
    ) { }

  ngOnInit() {
    // this.eleicao = new Eleicao();
    this.token = sessionStorage.getItem("token");
    this.idEleicao = sessionStorage.getItem("idEleicao");
    this.getEleicao(this.idEleicao, this.token);
  }

  getEleicao(idEleicao: number, token: any) {
    this.eleicaoServices.getById(idEleicao, token).then((eleicao: Eleicao) => {
      this.idEleicao = eleicao;
      console.log("ELEICAO: "+this.idEleicao);
      //sessionStorage.clear();
    }).catch(err => {
      this.router.navigate(['/error-sessao']);
    });
  }
  
  volta(){
    window.history.back();
}
}
